import { useState } from "react";
import { IoArrowBackCircle } from "react-icons/io5";

// eslint-disable-next-line react/prop-types
const Back = ({
  kata = "Kembali",
  color = "bg-gradient-to-tr from-cyan-500 to-blue-400",
  ...props
}) => {
  const [hovered, setHovered] = useState(false);

  return (
    <button
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className={`
        flex items-center rounded-full text-white ${color}
        shadow-md hover:shadow-lg
        transition-all duration-300 ease-out
        px-3 sm:px-4 py-2 sm:py-2.5
        relative overflow-hidden
      `}
      {...props}
    >
      {/* Icon */}
      <IoArrowBackCircle
        className={`text-2xl sm:text-2.5xl md:text-3xl transition-transform duration-300 ${
          hovered ? "translate-x-0" : "-translate-x-0.5"
        }`}
      />

      {/* Sliding text */}
      <span
        className={`
          font-semibold ml-2
          text-sm sm:text-base
          transition-all duration-300 ease-out
          ${
            hovered
              ? "max-w-[100px] opacity-100 translate-x-0"
              : "max-w-0 opacity-0 -translate-x-2"
          }
          whitespace-nowrap
        `}
      >
        {kata}
      </span>
    </button>
  );
};

export default Back;
